import { Box, KeyboardArrowRightIcon, makeStyles, Theme } from '@freighthub/silhouette-core'
import classnames from 'classnames'
import { CSSProperties, FC } from 'react'
import { useI18n } from 'utils/localisation'

import { Cargo, cargoString } from './Cargo'

const useStyles = makeStyles<Theme>((theme) => ({
  simpleRoute: {
    margin: theme.spacing(4, 0, 0),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: theme.typography.body2.fontSize,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  location: {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.5, 2),
    width: '25%',
    borderRadius: 4,
    fontSize: theme.typography.body2.fontSize,
    alignSelf: 'stretch',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cargoItem: {
    margin: theme.spacing(0.25, 0),
    borderRadius: 4,
    padding: theme.spacing(1, 2),
    textAlign: 'center',
    border: `2px solid ${theme.palette.divider}`,
  },
}))

type CargoRouteProps = {
  from: string
  to: string
  cargo: Cargo[]
  style?: CSSProperties
  className?: string
}

export const CargoRoute: FC<CargoRouteProps> = ({ from, to, cargo, style, className }) => {
  const localizationStore = useI18n()
  const classes = useStyles()

  return (
    <div className={classnames(classes.simpleRoute, className)} style={style}>
      <div className={classes.location}>{from}</div>
      <KeyboardArrowRightIcon />
      <Box width="30%" display="flex" flexDirection="column" justifyContent="center" alignItems="stretch">
        {cargo.map((item, i) => {
          return (
            <div key={i} className={classes.cargoItem}>
              {cargoString(item, localizationStore)}
            </div>
          )
        })}
      </Box>
      <KeyboardArrowRightIcon />
      <div className={classes.location}>{to}</div>
    </div>
  )
}
